import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FaqSection() {
  const faqs = [{
    q: '¿Tengo que dejar de usar el refuerzo positivo?',
    a: 'No, lo usamos con precisión quirúrgica para que sea 10 veces más efectivo.'
  }, {
    q: '¿Funciona para todas las razas?',
    a: 'Sí, todos los cachorros comparten los mismos instintos biológicos de limpieza y sueño.'
  }, {
    q: '¿Es muy difícil de seguir?',
    a: 'Está diseñado para personas ocupadas; son pasos directos y sin teoría innecesaria.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section bg="cream" data-id="element-24">
      <div className="text-center mb-12" data-id="element-25">
        <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-26">
          Preguntas Frecuentes
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-27">
        {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-cream-dark overflow-hidden shadow-sm" data-id="element-28">
            <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-29">
              <span className="font-bold text-lg text-navy" data-id="element-30">{faq.q}</span>
              <ChevronDown className={`w-5 h-5 text-navy/50 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-31" />
            </button>
            <AnimatePresence data-id="element-32">
              {openIndex === idx && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-33">
                  <div className="px-6 pb-5 text-navy/70" data-id="element-34">{faq.a}</div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}